import { useSessionStore } from '@/lib/store/sessionStore';

export function useActiveSession() {
  return useSessionStore((s) => s.sessions.find((x) => x.id === s.activeId));
}
